export default __webpack_public_path__ + "static/media/t-shirt.7f7066fb.jpg";